// ── Toggle: true = fetch from API, false = use dummy data
export const USE_API = true;

export const SOURCES = ["Auto", "Instagram", "Poster"];
export const DUMMY_LOCATIONS = ["Delhi", "Gurugram", "Bhiwali","Jaipur"];

export const EMPTY_FILTERS = {
  search: "", status: "All",
  createdFrom: "", createdTo: "",
  startFrom: "", startTo: "",
  endFrom: "", endTo: "",
};

// Keep field names consistent everywhere
export const normalizeAsset = (a, campaignId) => ({
  id: a._id || a.id,
  campaignId: a.campaignId || campaignId,
  name: a.assetName || a.name,
  code: a.assetCode || a.code,
  desc: a.desc ,
  source: a.source || "",
  location: a.location || "",
  workers: a.totalWorkers ?? a.workers ?? 0,
  isActive: a.isActive !== undefined ? a.isActive : a.status !== "inactive",
  createdBy: a.createdBy || "-",
  createdAt: a.createdAt || "",
  updatedBy: a.updatedBy || "",
  updatedAt: a.updatedAt || "",
});

const normLoc = (l) =>
  typeof l === "string" ? { id: l, name: l } : { id: l._id || l.id, name: l.name || "" };

export const normalizeCampaign = (c) => {
  const code = c.campaign_id || c.campaignCode || c.code;
  const id = c._id || code;
  const status = c.status || (c.isActive === false ? "inactive" : "active");
  const assets = (c.assets || []).map((a) => normalizeAsset(a, id));
  const activeA = c.active_assets ?? assets.filter((a) => a.isActive).length;
  const inactiveA = c.inactive_assets ?? assets.filter((a) => !a.isActive).length;

  return {
    id,
    code,
    name: c.name,
    locations: (c.locations || []).map(normLoc),
    startDate: toDay(c.start_date || c.startDate),
    endDate: toDay(c.end_date || c.endDate),
    status,
    isActive: status === "active",
    description: c.description || "",
    totalWorkers: c.workers_registered ?? c.totalWorkers,
    counts: {
      total: c.total_assets ?? assets.length,
      active: activeA,
      inactive: inactiveA,
      expired: c.expired_assets ?? 0,
    },
    assets,
    createdBy: c.created_by || c.createdBy || "-",
    createdAt: c.createdAt || c.created_at || "",
    updatedBy: c.updatedBy || "",
    updatedAt: c.updatedAt || c.updated_at || "",
  };
};

export const toDay = (v) => (v ? String(v).slice(0, 10) : "");

export const fmtDate = (v) => {
  const d = toDay(v);
  if (!d) return "-";
  return new Date(d + "T00:00:00").toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const workersOf = (c) =>
  c.totalWorkers ?? c.assets.reduce((t, a) => t + (a.workers || 0), 0);

export const countAssets = (assets) => {
  const active = assets.filter((a) => a.isActive).length;
  return { total: assets.length, active, inactive: assets.length - active };
};

export const workersSplit = (c) => {
  const active = c.assets.filter((a) => a.isActive).reduce((t, a) => t + (a.workers || 0), 0);
  return { active, inactive: Math.max(workersOf(c) - active, 0) };
};

const inRange = (v, from, to) => (!from || v >= from) && (!to || v <= to);

// Combined filtering: a campaign must match every selected criterion
export const applyFilters = (list, f) => {
  const q = f.search.trim().toLowerCase();
  return list.filter(
    (c) =>
      (!q || c.name.toLowerCase().includes(q) || c.code.toLowerCase().includes(q)) &&
      (f.status === "All" || (f.status === "Active") === c.isActive) &&
      inRange(toDay(c.createdAt), f.createdFrom, f.createdTo) &&
      inRange(c.startDate, f.startFrom, f.startTo) &&
      inRange(c.endDate, f.endFrom, f.endTo)
  );
};

// Next free 3-digit suffix for a campaign's assets
export const nextSuffix = (campaign) => {
  const used = (campaign?.assets || []).map((a) => parseInt(String(a.code).slice(-3), 10));
  let n = 1;
  while (used.includes(n)) n++;
  return String(n).padStart(3, "0");
};

export const DUMMY_CAMPAIGNS = [
  {
    id: "1", name: "Diwali", code: "DW26", locations: ["Delhi", "Gurugram"],
    startDate: "2026-10-01", endDate: "2026-11-30", isActive: true, description: "hiring for tech",
    createdBy: "Harsh", createdAt: "2026-09-20", updatedBy: "", updatedAt: "",
    assets: [
      { id: "a1", campaignId: "1", name: "asset1", code: "DW26AS1", source: "poster", location: "Delhi", workers: 142, isActive: true, createdBy: "Abhay", createdAt: "2026-09-22" },
      { id: "a2", campaignId: "1", name: "asset2", code: "DW26AS2", source: "Instagram", location: "Gurguram", workers: 88, isActive: true, createdBy: "Abhay", createdAt: "2026-09-25" },
    ],
  },

];